import axios from "axios";
import Router from "@/router/index";
import Element from "element-ui";
import {baseURL} from '@/config/baseURL.js'
const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  baseURL,
  // baseURL: '',
  timeout: 100000,
});

// 请求拦截
service.interceptors.request.use(
  (config) => {
    if (
      !config.url.includes("login") &&
      !config.url.includes("registerCode") &&
      !config.url.includes("register")
    ) {
      const token = sessionStorage.getItem("token");
      if (token) {
        config.headers.token = token;
      } else {
        // Element.Message.error('未登录，请登录！')
      }
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);
// 响应拦截
service.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      // if (response.data.code !== 200) {
      //   Element.Message.error(response.data.data);
      // }
      return response.data;
    } else {
      Promise.reject();
    }
  },
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 403:
          setTimeout(() => {
            Router.push("/backstage/index");
          }, 1200);
          break;
        case 401:
          setTimeout(() => {
            Router.push("/backstage/index");
          }, 1200);
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default service;
